import { Body } from "./Body";
import { Header } from "./Header";
import { Root } from "./Root";

export const Inset = Object.assign(Root, {
  Header,
  Body,
});
